import { render, staticRenderFns } from "./AQI.vue?vue&type=template&id=207bd089&scoped=true&"
import script from "./AQI.vue?vue&type=script&lang=js&"
export * from "./AQI.vue?vue&type=script&lang=js&"
import style0 from "./AQI.vue?vue&type=style&index=0&id=207bd089&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bd089",
  null
  
)

export default component.exports